import styled from '@emotion/styled';

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;
